import api from '../../common/api';
import url from '../../common/url';
import auth from '../../common/auth';
import { Bus, Stops } from '../../common/bus';
import { localStorage, bags } from '../../common/localStorage';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isAuthenticated: false,
        profile: {},
        catchers: [],
        lastCatch: {},
        world: {
            name: 'World',
            id: 260,
            level: 0,
            path: 'World',
            isProtected: true,
        },
        country: {
            name: 'Norge',
            id: 258,
            level: 2,
            path: 'World/Europe/Norge',
            isProtected: true,
        },
    },
    getters: {
        isMyCatcher: state => id => state.isAuthenticated && state.catchers.findIndex(i => i.id === id) >= 0,
        isMyRegion: state => id => id > 0 && state.profile.id < 3,
    },
    mutations: {
        setLastCatch(state, lastCatch) {
            state.lastCatch = lastCatch || {};
            localStorage.save(bags.LAST_CATCH, state.lastCatch);
        },
        loading(state, isLoading) {
            state.isLoading = isLoading;
        },
        profile(state, profile) {
            if (!profile) localStorage.clear();
            else localStorage.save(bags.PROFILE, profile);
            state.profile = profile || {};
            state.isAuthenticated = profile !== null;
            state.catchers = [];
            state.lastCatch = {};
        },
        catcherPage(state, page) {
            if (!page) return;
            state.catchers = [...state.catchers, ...page.items];
            if (!page.nextUri) localStorage.save(bags.CATCHERS, state.catchers);
        },
    },
    actions: {
        async getProfile({ commit, dispatch }) {
            commit('loading', true);
            const refresh = await auth.refreshAuth();
            commit('loading', false);
            if (refresh.error === auth.ERROR_UNAUTHORIZED) {
                commit('unloadProfile');
                return;
            }
            const profile = localStorage.load(bags.PROFILE);
            if (profile) {
                commit('profile', profile);
                commit('setLastCatch', localStorage.load(bags.LAST_CATCH));
                commit('catcherPage', { items: localStorage.load(bags.CATCHERS) });
            } else dispatch('loadProfile');
        },
        async loadProfile({ commit, dispatch }) {
            commit('loading', true);
            const auth0 = await auth.getAuth();
            if (!auth0.error === auth.ERROR_WHATEVER) {
                commit('loading', false);
                Bus.$emit(Stops.TOAST, 'Kunne ikke hente profildata. Prøv igjen senere.');
                return;
            }
            const profile = await api.post(url.getProfiles(), auth0);
            commit('loading', false);
            if (profile.error) {
                Bus.$emit(Stops.TOAST, 'Kunne ikke hente profildata. Prøv igjen senere.');
                return;
            }
            commit('profile', profile);
            dispatch('loadCatchers', url.getCatchers());
        },
        async unloadProfile({ commit }) {
            commit('loading', true);
            const result = await auth.dropAuth();
            commit('loading', false);
            if (result.error) {
                Bus.$emit(Stops.TOAST, 'Kunne ikke logge ut. Prøv igjen senere.');
                return;
            }
            commit('profile', null);
        },
        async loadCatchers({ commit, dispatch }, uri) {
            if (!uri) return;
            commit('loading', true);
            const page = await api.get(uri);
            commit('loading', false);
            if (page.error) {
                Bus.$emit(Stops.TOAST, 'Kunne ikke hente dine fiskere. Prøv igjen senere.');
                return;
            }
            commit('catcherPage', page);
            dispatch('loadCatchers', page.nextUri);
        },
    },
};
